/**
 * Who to contact about a Rigo bill.
 *
 * Hard-coded here, and it should not be. RigoSub's messaging model carries a per-customer account
 * owner and a per-product sender identity (`DECISIONS.md`, "Messaging 5–10"), but
 * `GET /api/v1/subscription-status` returns none of it — it carries a status, an amount and two
 * dates and nothing about who to call. These are RigoSub's `SENDER` defaults; when the status
 * payload grows contact fields, delete this file and read them.
 *
 * There is deliberately no payment link. There is no self-serve portal to link to: a customer
 * settles by bank transfer against the bill RigoSub issued, and a button that promised otherwise
 * would lead nowhere.
 */
export const BILLING_CONTACT = {
  email: "billing@rigo.com.np",
  phone: "+977 1 4102030",
} as const;
